export default __webpack_public_path__ + "static/media/touchStayLogo.211f601e.png";